import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createRewardApi, storeRewardApi } from './rewardSlice';
import isEmpty from 'lodash/isEmpty';
import { RequestBodyConverter } from '../RequestBodyConverter';
import RewardForm from './RewardForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { initialValues } from './initialValue';

function RewardCreate() {
    const [resetCount, setResetCount] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.

        dispatch(storeRewardApi({ navigate, values }));
    };

    return (
        <RewardForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default RewardCreate;
